import {onFind} from "@elements/init-modules-in-scope";
import {findIn, findAllIn, closest, on} from '@elements/dom-utils';
import asyncAppend from "@elements/async-append";
import axios from "axios";

const selectors = {
    base: '.js-payment',
    paymentItem: '.js-payment__item',
    paymentBtn: '.js-payment__btn',
    voucherInput: '.js-payment__voucher-input',
    target: '.js-payment__result',
    loading: '.js-payment__loading',
};

export function init () {
    console.log('init payment form');
    onFind(selectors.base, function (el) {
        onFind(selectors.paymentItem, function (paymentItem) {
            let paymentBtns = findAllIn(selectors.paymentBtn, paymentItem);
            let baseElement = closest(selectors.base, paymentItem);
            let paymentURL = baseElement.dataset.paymentUrl;

            paymentBtns.map(function(paymentBtn) {
                on('click', function (evt) {
                    evt.preventDefault();

                    let voucherInput = findIn(selectors.voucherInput, paymentItem);
                    let voucherAction = voucherInput.dataset.action;

                    if (voucherInput) {
                        let data = {
                            voucherCode: voucherInput.value,
                            action: voucherAction,
                        };

                        if (paymentURL) {
                            loadContent(baseElement, paymentURL, data, 'POST');
                        } else {
                            console.warn("payment-form.js: no paymentURL is set");
                        }
                    } else {
                        console.warn("payment-form.js: no voucherInput is set");
                    }
                }, paymentBtn);
            });
        })
    });

    function loadContent(baseElement, url, data, method) {

        let pendingRequest = null;
        if (method === 'GET') {
            pendingRequest = axios({method: 'GET', url: url, params: data});
        } else {
            pendingRequest = axios({method: 'POST', url: url, data: data});
        }

        let results = findAllIn(selectors.target, baseElement);
        let targetsByResultId = {};

        results.forEach((element) => {
            let resultId = element.dataset.paymentResultId;
            if (targetsByResultId[resultId]) {
                targetsByResultId[resultId] = [...targetsByResultId[resultId], element];
            } else {
                targetsByResultId[resultId] = [element];
            }
        });

        asyncAppend({
            target: targetsByResultId,
            loading: findAllIn(selectors.loading, baseElement),
        }, pendingRequest.then((x) => x.data));
    }
}